"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertSummaryToText = void 0;
const __1 = require("../..");
const convertSummaryToText = (orderLineJSONObj) => {
    const variant = orderLineJSONObj?.variant;
    let text = "";
    const has_legs = variant?.regions?.length > 1;
    variant?.regions.forEach((region, idx) => {
        const number = idx + 1;
        text += `<u style="text-transform:uppercase"><strong>${has_legs ? `Leg ${number}: ` : ``}${region.summary_long} in ${region.name}</strong></u><br/>`;
        text += `${region.start_date} - ${region.end_date}<br/><br/>`;
        if (region?.hotels?.stays?.length > 0) {
            text += `<u><strong>${region.hotels.title}</strong></u><br/><br/>`;
            region.hotels.stays.forEach((stay) => {
                text += `<strong>${stay.date}: ${stay.hotel.name.en} ${stay.hotel.star_rating > 0 && `(${stay.hotel.star_rating}&ast;)`}</strong><br/>`;
                stay.descriptions.forEach((desc) => {
                    text += `- ${desc.quantity} x ${desc.room.room.name.en} (${(0, __1.occupancyDescription)(desc.occupancy_raw / desc.quantity)}/${desc.room.board}) - ${desc.occupancy}<br/>`;
                });
                if (stay.check_in_out) {
                    text += `- ${stay.check_in_out}<br/>`;
                }
                if (stay.warnings.length > 0) {
                    stay.warnings.forEach((warning) => {
                        text += `- ${warning}<br/>`;
                    });
                }
            });
        }
        if (region?.golf?.rounds?.length > 0) {
            text += `<br/>`;
            text += `<u><strong>${region.golf.title}</strong></u><br/><br/>`;
            region.golf.rounds.forEach((round) => {
                text += `<strong>${round.date}: ${round.course.name.en}</strong><br/>`;
                round.descriptions.forEach((desc) => {
                    text += `- ${desc.replace("  ", " ")}<br/>`;
                });
                text += `<br/>`;
            });
        }
        if (region?.excursions?.trips?.length > 0) {
            text += `<u><strong>${region.excursions.title}</strong></u><br/>`;
            region.excursions.trips.forEach((trip) => {
                text += `${trip.date}: ${trip.excursion.name.en}<br/>`;
                trip.descriptions.forEach((desc) => {
                    text += `- ${desc}<br/>`;
                });
                text += `<br/>`;
            });
        }
        if (region?.transfers?.trips?.length > 0) {
            text += `<u><strong>${region.transfers.title}</strong></u><br/><br/>`;
            region.transfers.trips.forEach((trip) => {
                text += `- ${trip.journey} in a ${(0, __1.decapitalizeFirstLetter)(trip.vehicle.name.en)} (${trip.passengers})<br/>`;
            });
            text += `<br/>`;
        }
    });
    if (orderLineJSONObj?.agent?.config?.itinerary?.enabled) {
        text += `<br/><a href="https://${orderLineJSONObj?.agent?.config?.itinerary?.slug}.your-golf-itinerary.com/${variant.ref}" target="_blank">Click here to view your itinerary</a>`;
    }
    return text;
};
exports.convertSummaryToText = convertSummaryToText;
